import { GetCurrentAddOnsPayload } from '@mfe/shared/schema-types';

export const findAddOn = (
  currentAddOns: GetCurrentAddOnsPayload[] | null,
  addOnName: string
) => currentAddOns?.find((addon) => addon.name === addOnName);
